import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { toast as sonnerToast } from 'sonner';

import { cn } from '../components/lib/utils';

export const showValidationToast = ({
  message,
  descriptions
}: {
  message: string;
  descriptions: string[];
}) => {
  return sonnerToast(message, {
    duration: 10000,
    description: (
      <ul className="mt-1 flex flex-col gap-0.5">
        {descriptions.map((desc, i) => (
          <li key={i}>{desc}</li>
        ))}
      </ul>
    ),
    unstyled: true,
    closeButton: true,
    icon: (
      <FontAwesomeIcon
        icon="fa-regular fa-circle-exclamation"
        className={cn('mt-1 shrink-0 text-base leading-none', 'text-red-600')}
      />
    ),
    classNames: {
      toast:
        'group flex w-[416px] items-start gap-3 rounded-[10px] border border-base-border bg-base-card py-3 pl-4 pr-10 absolute bottom-0 h-max hover:cursor-pointer [&:not(:first-child)>div]:data-[expanded=false]:opacity-0',
      title: 'text-p-s font-medium leading-5 line-clamp-2 text-red-600',
      description: 'text-p-s leading-5 font-medium text-red-600/90',
      closeButton:
        'opacity-0 group-hover:opacity-100 absolute top-2 right-2 w-4 h-4 [&>svg]:h-4 [&>svg]:w-4 text-red-600/70'
    }
  });
};
